import { Slide, useTheme } from "@mui/material";
import { Bot, User } from "lucide-react";
import React from "react";
import ReactMarkdown from "react-markdown";
import {
  AvatarContainer,
  Container,
  MessageBox,
  MessageContainer,
  SuggestedQuestionChip,
  SuggestedQuestionsRow } from "./AISupportChatMessageBox.styles";
import { ChatAgentMessage } from "../../AISupportChat.types";
import AISupportChatSpinner from "../AISupportChatSpinner/AISupportChatSpinner.component";

interface AISupportChatMessageBoxProps {
  index: number;
  message: ChatAgentMessage;
  onSuggestionClick?: (question: string) => void;
}

const AISupportChatMessageBox = ({
  index,
  message,
  onSuggestionClick
}: AISupportChatMessageBoxProps) => {
  const theme = useTheme();
  const isAI = message.sender === "assistant";
  const hasContent = message.response !== "";
  const suggestedQuestions = message.suggested_questions ?? [];


  const MessageAvatar = () => {
    return (
      <>
        { isAI ? (
          <Bot aria-label={ "Avatar" } color={ theme.customColors.textPrimaryCta } size={ 24 } />
        ) : (
          <User aria-label={ "Avatar" } color={ theme.customColors.textWidget } size={ 24 } />
        ) }
      </>
    );
  };

  return (
    <Slide direction={ "up" } in mountOnEnter unmountOnExit>
      <div>
        <Container isAI={ isAI } messageIndex={ index } gap={ "10px" }>
          <AvatarContainer theme={ theme } isAI={ isAI }>
            <MessageAvatar />
          </AvatarContainer>
          <MessageContainer theme={ theme } isAI={ isAI }>
            { !hasContent ? (
              <AISupportChatSpinner />
            ) : (
              <MessageBox theme={ theme } isAI={ isAI }>
                <ReactMarkdown>{ message.response }</ReactMarkdown>
              </MessageBox>
            ) }
          </MessageContainer>
        </Container>

        { isAI && hasContent && suggestedQuestions.length > 0 && (
          <SuggestedQuestionsRow>
            { suggestedQuestions.map((question, questionIndex) => (
              <SuggestedQuestionChip
                key={ `sugg_${index}_${questionIndex}` }
                chipIndex={ questionIndex }
                onClick={ () => onSuggestionClick?.(question) }
                disabled={ !onSuggestionClick }
              >
                { question }
              </SuggestedQuestionChip>
            )) }
          </SuggestedQuestionsRow>
        ) }
      </div>
    </Slide>
  );
};

export default AISupportChatMessageBox;
